import './Skills.css'

export default function Skills() {
  return (
    <div className='skills md:mx-44 mx-4 flex flex-col mt-16 mb-20 md:mb-32'>
      <hr className='' />
    </div>
  )
}
